export const getTeacherCardDetails = (cardData) => {
    const teacherTitle = cardData?.teacher?.firstName || '';
    const teacherImage = cardData?.teacher?.profilePicId;
    return {teacherTitle, teacherImage};
}